import { URLS } from "../components/urls";

export function getBoardSettings(token) {
  return new Promise((resolve, reject) => {
    fetch(`${URLS.backendBoardSettings}/get-settings`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getColorCodes(token) {
  return new Promise((resolve, reject) => {
    fetch(`${URLS.colorCodes}/get-color-codes`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
